import React from 'react';

const clickableTextStyle = {
    color: '#1A283E', // Corresponds to theme.colors.primary
    cursor: 'pointer',
    textDecoration: 'underline'
};

export const renderCommentCell = (comment, title, onViewComment) => {
    const MAX_LENGTH = 25;
    if (!comment) return '-';

    if (comment.length > MAX_LENGTH) {
        return (
            <span
                style={clickableTextStyle}
                title="Ver comentario completo"
                onClick={() => onViewComment(title, comment)}
            >
                {`${comment.substring(0, MAX_LENGTH)}...`}
            </span>
        );
    }
    return comment;
};
